import React from 'react';

interface Column {
  width: string;
  minWidth?: string;
}

interface TableLoaderProps {
  columns: Column[];
}

const TableLoader: React.FC<TableLoaderProps> = ({ columns }) => {
  return (
    <div className="w-full">
      {[...Array(13)].map((_, index) => (
        <div 
          key={index} 
          className="animate-pulse flex items-center border-b border-[#EEEEEE] h-[36px]"
        >
          <div className="pl-6 w-[40px]">
            <div className="h-4 w-4 bg-[#EEEEEE] rounded"></div>
          </div>
          {columns.map((column, idx) => (
            <div 
              key={idx} 
              className="px-4 border-r border-[#EEEEEE]"
              style={{ 
                width: column.width,
                minWidth: column.minWidth
              }}
            >
              <div className="h-4 bg-[#EEEEEE] rounded w-3/4"></div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default TableLoader; 